/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/ContentBottom.tsx
 * Created:       Wed Apr 16 2025
 * Modified By:   Greg Olive
 * Last Modified: Wed Apr 16 2025
 */

import React, { useContext } from 'react';
import { FormContext } from "@proxy/_contexts";
import { decodeBase64 } from "@root/_utils";

const ContentBottom = () => {

  const { settings } = useContext(FormContext);

  return ((settings?.global?.appearance?.purchase_content_bottom) ?
    <div
      className="gc__content-bottom"
      dangerouslySetInnerHTML={{
        __html: decodeBase64(settings.global.appearance.purchase_content_bottom)
      }}
    ></div>
  : null);
};

export default ContentBottom;
